(function($){
    //shipping_method_0_flexible_shipping_single18
    $(document).ready(function($) {
        $(document.body).on('updated_checkout', function() {
            $('#paczkomat_id, #paczkomat_id + div').hide();
            if($('[for="shipping_method_0_flexible_shipping_single18"]').prev('input').prop('checked') == true) {
                $('#shipinp').remove();
                $('<div class="inpost-box" id="shipinp">' + $('.inpost-box').html() + '</div>').insertAfter('[for="shipping_method_0_flexible_shipping_single18"]');
                setTimeout(function(){
                    // set_inpost_desc();
                    // $('#shipinp .tt').html(text);
                }, 2000)

                var int = setInterval(function(){
                    if($('select#paczkomat_id').length > 0){
                        $('<input value="0" name="paczkomat_id" id="paczkomat_id" />').insertAfter('select#paczkomat_id');
                        $('select#paczkomat_id').remove();
                        // clearInterval(int);
                    }
                }, 100)

            }
        });

    });
    $('body').on('click', '.in-btn button', function(e){
        e.preventDefault();
        $('body').find('#open-geowidget').first().click();
        // $('#paczkomat_id, #paczkomat_id + div').show();
    })
    $('body').on('change', '#paczkomat_id', function(){
        // set_inpost_desc();
    })
    function set_inpost_desc(){
        var value = $('#paczkomat_id').val();
        var text = $('#paczkomat_id option:selected').text();
        $('#shipinp .subt').html(value);
        $('#shipinp .tt').html($('#paczkomat_id option:selected').html().replace('['+$('#paczkomat_id').val()+'] ', '').replace($('#paczkomat_id').val() + ', ', ''));
        $('#paczkomat_id').insertAfter('#shipinp');
    }
})(jQuery)